import { Box, MenuItem, TextField } from "@mui/material";
import { DashboardDateFilter } from "./DashboardDateFilter";
import { GlobalFilterConfig, GlobalFilterValues } from "./types";

const ALL_OPTION_VALUE = "__all__";

type DashboardFilterBarProps = {
    globalFilters: Array<GlobalFilterConfig>;
    values: GlobalFilterValues;
    onChange: (filterKey: string, value: string | number | null) => void;
};

export const DashboardFilterBar = ({ globalFilters, values, onChange }: DashboardFilterBarProps) => {
    if (globalFilters.length === 0) return null;

    return (
        <Box display="flex" gap={3} flexWrap="wrap">
            {globalFilters.map((globalFilter) => {
                if (globalFilter.type === "datePreset") {
                    return (
                        <DashboardDateFilter
                            key={globalFilter.key}
                            label={globalFilter.label}
                            filterKey={globalFilter.key}
                            values={values}
                            onChange={onChange}
                            presets={globalFilter.presets}
                        />
                    );
                }

                if (globalFilter.type === "choice") {
                    return (
                        <TextField
                            key={globalFilter.key}
                            select
                            size="small"
                            label={globalFilter.label}
                            value={values[globalFilter.key] ?? globalFilter.defaultValue}
                            onChange={(event) => onChange(globalFilter.key, event.target.value)}
                            sx={{ minWidth: 180 }}
                        >
                            {globalFilter.options.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    );
                }

                const selectedValue = values[globalFilter.key];
                return (
                    <TextField
                        key={globalFilter.key}
                        select
                        size="small"
                        label={globalFilter.label}
                        value={selectedValue === null || selectedValue === undefined ? ALL_OPTION_VALUE : selectedValue}
                        onChange={(event) => {
                            const newValue = event.target.value === ALL_OPTION_VALUE ? null : event.target.value;
                            onChange(globalFilter.key, newValue);
                        }}
                        sx={{ minWidth: 180 }}
                    >
                        <MenuItem value={ALL_OPTION_VALUE}>Todas</MenuItem>
                        {globalFilter.options.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                );
            })}
        </Box>
    );
};
